import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { browserModeKey } from './pages/toolBrowser/client';
import './styles.css';
import './styles/marketing-landing.css';
import './styles/executor-management.css';
import './styles/interactive-agent.css';
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

if ('serviceWorker' in navigator && window.location.pathname !== '/login/tool-token' &&
    window.location.pathname !== '/tool-browser' && sessionStorage.getItem(browserModeKey) !== 'scoped') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('Service worker registration failed', err);
    });
  });
}
